import { List } from './List'

export class RoleParent extends List {
  constructor(obj) {
    super(Role, obj)
  }
}

export class Role {
  constructor(obj = {}) {
    this.id = obj?.id || null
  }

  getForAPI() {
    return {
      id: this.id
    }
  }
}
